import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWayBack = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 8,
	viewBox: "0 0 15 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2.44 0H0L2.46 2.46L7.36 7.36L9.09 5.61L5.94 2.46H14.61V0H2.63H2.44Z",
		fill: "#AA00FF"
	})]
});
const ForwardRef = forwardRef(SvgWayBack);
export { ForwardRef as ReactComponent };
